import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Interpolate from 'react-interpolate-component';
import isEmpty from 'lodash/isEmpty';
import { getCurrentCampaign }from '../campaign.selectors';

import colors from '../../../utils/colors';
import BaseContainer from '../../../ui/BaseContainer';
import { ContentSection } from '../../pages/components';
import { Localize } from '../../../locale/localization';
import { formatDate, isTodayOrAfterToday } from '../../../utils/date-utils';

const ContentWrapper = BaseContainer.extend`
  width: 100%;
	background-color: ${colors.NOTIFICATION};
	border-radius: 0.3125rem;
	box-sizing: border-box;
	color: ${colors.BRAND_RED};
  margin: 0 auto;
	padding: 1rem 1.25rem;
  font-family: FyranSans-SemiBold;
  font-size: 1.125rem;
  line-height: 1.375rem;
`;

const CampaignAlertBlock = (props) => {
  const {
    currentCampaign
  } = props;
  if(!currentCampaign || isEmpty(currentCampaign.previousCampaign) || !!(currentCampaign && currentCampaign.endDate)) {
    return null;
  }

  const prizeShopStillOpen = !!(currentCampaign && currentCampaign.previousCampaign && !!currentCampaign.previousCampaign.prizeShopEndDate && isTodayOrAfterToday(moment(currentCampaign.previousCampaign.prizeShopEndDate)));
  return (
    <ContentSection>
      <ContentWrapper>
        {prizeShopStillOpen ? (
          <Interpolate with={{ date: formatDate(currentCampaign.previousCampaign.prizeShopEndDate) }} unsafe format={Localize('campaign.end.alert')} />
        ) : (
          Localize('campaign.prize-shop.ended.alert')
        )}
      </ContentWrapper>
    </ContentSection>
  );
};

const mapStateToProps = (state) => {
  const currentCampaign = getCurrentCampaign(state);
  return {
    currentCampaign,
  };
};

const ConnectedCampaignAlertBlock = connect(
  mapStateToProps,
  null,
)(CampaignAlertBlock);

export default ConnectedCampaignAlertBlock;


// WEBPACK FOOTER //
// ./src/modules/campaign/components/CampaignAlertBlock.js